import { sdk as imageSdk } from '@wix/image-kit';
const HTTP_PREFIX = 'http';
const WIX_STATICS_PREFIX = 'https://static.wixstatic.com';
const ALL_PATH = '/media/';
const SVG_PATH = '/shapes/';
const MEDIA_PREFIX = 'media/';
const DEFAULT_TIMEOUT_MS = 2000;
const DEFAULT_MAX_HEIGHT = 150;
const DEFAULT_MAX_WIDTH = 226;
export const removePrefix = (value, prefix) => value.startsWith(prefix) ? value.slice(prefix.length) : value;
export const isSVGfile = file => /\.svg$/i.test(file);
export const isJPGfile = file => /\.(jpe?g)$/i.test(file);
export const isGIFfile = file => /\.gif$/i.test(file);
export const getImageFilenameFromUrl = url => {
  try {
    const {
      pathname
    } = new URL(url);
    const parts = pathname.split('/');
    const mediaIndex = parts.findIndex(p => p === 'media' || p === 'shapes');
    if (mediaIndex !== -1 && parts[mediaIndex + 1]) {
      return parts[mediaIndex + 1];
    }
    return '';
  } catch {
    return url;
  }
};
const isWixImage = imageUri => imageUri.startsWith(WIX_STATICS_PREFIX) || !imageUri.startsWith(HTTP_PREFIX);
export const resolveImageUrl = (imageUrl, targetWidth, targetHeight) => {
  if (!isWixImage(imageUrl)) {
    return imageUrl;
  }
  const imageFilename = getImageFilenameFromUrl(imageUrl);
  const url = imageSdk.getScaleToFillImageURL(imageFilename, 0, 0, targetWidth, targetHeight);
  if (isSVGfile(imageFilename)) {
    return url.replace(ALL_PATH, SVG_PATH);
  }
  return url;
};
export const originalImageUrl = imageUrl => {
  if (imageUrl.startsWith(HTTP_PREFIX)) {
    return imageUrl;
  }
  const cleanUrl = removePrefix(imageUrl, MEDIA_PREFIX);
  return isSVGfile(cleanUrl) ? `https://static.wixstatic.com/shapes/${cleanUrl}` : `https://static.wixstatic.com/media/${cleanUrl}`;
};
export const withTimeout = (promise, ms) => new Promise(async (resolve, reject) => {
  const timer = setTimeout(() => reject(new Error('Timeout')), ms);
  try {
    const result = await promise;
    clearTimeout(timer);
    resolve(result);
  } catch (err) {
    clearTimeout(timer);
    reject(err);
  }
});
export const getImageMetadata = async imageUrl => {
  return new Promise((resolve, _reject) => {
    const img = new Image();
    img.addEventListener('load', () => {
      const {
        naturalWidth,
        naturalHeight
      } = img;
      document.head.removeChild(img);
      resolve({
        dimensions: {
          height: naturalHeight,
          width: naturalWidth
        }
      });
    });
    img.src = imageUrl;
    document.head.appendChild(img);
  });
};
export const resizeImageUrl = async function (uri, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    timeoutMs = DEFAULT_TIMEOUT_MS,
    maxHeight = DEFAULT_MAX_HEIGHT,
    maxWidth = DEFAULT_MAX_WIDTH
  } = options;
  let height = 300;
  let width = 300;
  try {
    const {
      dimensions
    } = await withTimeout(getImageMetadata(originalImageUrl(uri)), timeoutMs);
    height = (dimensions == null ? void 0 : dimensions.height) ?? height;
    width = (dimensions == null ? void 0 : dimensions.width) ?? width;
  } catch (error) {
    console.warn(`Failed to get image metadata for ${uri}, using default ${width}px x ${height}px dimensions`, error);
  }
  const scaleFactor = Math.min(maxWidth / width, maxHeight / height);
  const resizedWidth = Math.round(width * scaleFactor);
  const resizedHeight = Math.round(height * scaleFactor);
  return resolveImageUrl(uri, resizedWidth, resizedHeight);
};
//# sourceMappingURL=image-utils.js.map